import { t } from "i18next";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { LoadingSpinner } from "../../general/loading-spinner";
import { getGlobalAthleteRanking } from "../../../services/athlete";
import { Athlete, AthleteTeamSeason } from "../../../interfaces/athlete";
import { Col, Row } from "react-bootstrap";
import moment from 'moment';

export function AthletesRanking() {
    const params: any = useParams();

    const [athletes, setAthletes] = useState<Athlete[]>([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        getGlobalAthleteRanking()
            .then(response => {
                setAthletes(response.data);
                setLoaded(true);
            })
    }, []);
    
    return (
        <div className="athletes-ranking-container"> 
            <div className="inner">
            <h1>{ t("Athletes ranking") }</h1>
            { !loaded && 
                <LoadingSpinner />
            }
            { loaded &&
                <Row>
                    <Col xs={12} md={6}>
                        <div className="ranking-man">
                            {
                                athletes.filter((f: any) => f.sex == 'man').map((a: any, key) => {
                                    return (<div key={ 'athlete-' + a.id } className="athlete-tile ranking">
                                        <div className="position">
                                            {key + 1}
                                        </div>
                                        <div className="icon">
                                            { a.avatar.length > 0 &&
                                                <img src={ a.avatar[0].src } alt={ a.avatar[0].name } />
                                            }
                                        </div>
                                        <div className="title">
                                            <Link to={ '/athletes/' + a.id + '/view' } title={ a.name } target="_blank">
                                                { a.name }
                                            </Link>
                                            { a.birthdate &&
                                                <div className="years">
                                                    { moment(new Date()).diff(a.birthdate, 'years') + ' ' + t("years").toLowerCase() } 
                                                </div>
                                            }
                                            { a.registered_in.length > 0 &&
                                                <div className="teams">
                                                    {
                                                        a.registered_in.map((ats: AthleteTeamSeason) => {
                                                            return ats.club_name + '/' + ats.team_name;
                                                        }).join(', ')
                                                    }
                                                </div>
                                            }
                                        </div>
                                        <div className="points">
                                            <div className="value">{ a.points }</div>
                                            <div className="label">{ t("points_label") }</div>
                                        </div>
                                    </div>)
                                })
                            }
                        </div>
                    </Col>
                    <Col xs={12} md={6}>
                        <div className="ranking-man">
                            {
                                athletes.filter((f: any) => f.sex == 'woman').map((a: any, key) => {
                                    return (<div key={ 'athlete-' + a.id } className="athlete-tile ranking">
                                        <div className="position">
                                            {key + 1}
                                        </div>
                                        <div className="icon">
                                            { a.avatar.length > 0 &&
                                                <img src={ a.avatar[0].src } alt={ a.avatar[0].name } />
                                            }
                                        </div>
                                        <div className="title">
                                            <Link to={ '/athletes/' + a.id + '/view' } title={ a.name } target="_blank">
                                                { a.name }
                                            </Link>
                                            { a.birthdate &&
                                                <div className="years">
                                                    { moment(new Date()).diff(a.birthdate, 'years') + ' ' + t("years").toLowerCase() } 
                                                </div>
                                            }
                                            { a.registered_in.length > 0 &&
                                                <div className="teams">
                                                    {
                                                        a.registered_in.map((ats: AthleteTeamSeason) => {
                                                            return ats.club_name + '/' + ats.team_name;
                                                        }).join(', ')
                                                    }
                                                </div>
                                            }
                                        </div>
                                        <div className="points">
                                            <div className="value">{ a.points }</div>
                                            <div className="label">{ t("points_label") }</div>
                                        </div>
                                    </div>)
                                })
                            }
                        </div>
                    </Col>
                </Row>
            }
            </div>
        </div>
    );
}
